'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;
// import {FinishTaskButton} from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module2Act3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user, app: state.moduleData.data.module2.act3 };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2Act3, _Component);

  function Module2Act3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2Act3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2Act3.__proto__ || (0, _getPrototypeOf2.default)(Module2Act3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Comparing the cost of children\'s snacks',
      isCompleted: false,
      questions: [{
        choice: 'Coles fruit sticks',
        answer: '$8.50'
      }, {
        choice: 'Orange',
        answer: '$2.50'
      }, {
        choice: 'The Natural Confectionary Co \'Forbidden Fruits\'',
        answer: '$12.50'
      }, {
        choice: 'Carrots',
        answer: '$2.50'
      }, {
        choice: 'Uncle Toby\'s Muesli bars - multipack',
        answer: '$13.30'
      }, {
        choice: 'Pink lady apples',
        answer: '$3.50'
      }, {
        choice: 'Coles fruit filled bars, berry flavour',
        answer: '$14.60'
      }, {
        choice: 'White seedless grapes',
        answer: '$5.00'
      }, {
        choice: 'Honey Tiny Teddy biscuits',
        answer: '$17.05'
      }, {
        choice: 'Yoplait Yoghurt',
        answer: '$6.48'
      }, {
        choice: 'Shapes biscuits multipack',
        answer: '$17.50'
      }, {
        choice: 'Cheese (tasty)',
        answer: '$7.50'
      }, {
        choice: 'Smith\'s Original Potato Chips',
        answer: '$20.60'
      }, {
        choice: 'Golden Circle tinned pineapple in natural juice',
        answer: '$8.14'
      }, {
        choice: 'Mars Bar share pack',
        answer: '$23.40'
      }, {
        choice: 'Ryvitas (wholegrain)',
        answer: '$9.00'
      }, {
        choice: 'Uncle Toby\'s chewy apricot muesli bars',
        answer: '$23.70'
      }, {
        choice: 'English muffins (wholemeal)',
        answer: '$12.24'
      }, {
        choice: 'Bel Cheese dippers',
        answer: '$32'
      }, {
        choice: 'Fruit salad tubs',
        answer: '$12.76'
      }, {
        choice: 'Box of \'BBQ shapes\'',
        answer: '$32.90'
      }, {
        choice: 'Fresh fruit salad pot',
        answer: '$14.71'
      }, {
        choice: 'Uncle Toby\'s roll-ups rainbow fruit',
        answer: '$46.70'
      }, {
        choice: 'Strawberries',
        answer: '$15.60'
      }],
      answers: [{
        userAnswer: ''
      }, {
        userAnswer: ''
      }, {
        userAnswer: ''
      }, {
        userAnswer: ''
      }, {
        userAnswer: ''
      }, {
        userAnswer: ''
      }]
    }, _this.handleComplete = function () {
      var obj = _this.state;
      obj.isCompleted = true;
      _this.setState(obj);

      _this.props.updateModuleAct(_this.props.user.userId, _this.state.moduleId, _this.state.appId, obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleUserChoice = function (index, event) {
      var obj = _this.state;
      obj.answers[index].userAnswer = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * General function used to change state of object
   */


  /*
   * Enter user answer
   */


  (0, _createClass3.default)(Module2Act3, [{
    key: 'renderQuestion',
    value: function renderQuestion(lessHealthyChoice, lessHealthyPrice, healthyChoice, healthyPrice, index) {
      var styles = require('../../Modules.scss');
      var choice1 = lessHealthyChoice;
      var answer1 = lessHealthyPrice;
      var choice2 = healthyChoice;
      var answer2 = healthyPrice;
      var iteration = index;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.FormGroup,
          { onChange: this.handleUserChoice.bind(this, iteration) },
          _react2.default.createElement(
            ReactBootstrap.Radio,
            { name: iteration, value: choice1, inline: true, checked: this.state.answers[iteration].userAnswer === choice1 },
            choice1
          ),
          ' ',
          _react2.default.createElement(
            ReactBootstrap.Radio,
            { name: iteration, value: choice2, inline: true, checked: this.state.answers[iteration].userAnswer === choice2 },
            choice2
          )
        ),
        this.state.answers[iteration].userAnswer === choice2 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: styles.greenText },
            'You are correct! ',
            choice2,
            ' is ',
            answer2,
            ', and ',
            choice1,
            ' is ',
            answer1,
            ' per kilogram!'
          )
        ),
        this.state.answers[iteration].userAnswer === choice1 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: styles.orangeText },
            'You are incorrect, ',
            choice2,
            ' is actually ',
            answer2,
            ' per kilogram and ',
            choice1,
            ' is ',
            answer1,
            ' per kilogram.'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var questions = this.state.questions;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Which do you think is better value for money per kilogram?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Tip: it is less expensive to buy healthy snacks than you may have though!'
          ),
          this.renderQuestion(questions[0].choice, questions[0].answer, questions[1].choice, questions[1].answer, 0),
          this.state.answers[0].userAnswer && this.renderQuestion(questions[2].choice, questions[2].answer, questions[3].choice, questions[3].answer, 1),
          this.state.answers[1].userAnswer && this.renderQuestion(questions[4].choice, questions[4].answer, questions[5].choice, questions[5].answer, 2),
          this.state.answers[2].userAnswer && this.renderQuestion(questions[6].choice, questions[6].answer, questions[7].choice, questions[7].answer, 3),
          this.state.answers[3].userAnswer && this.renderQuestion(questions[8].choice, questions[8].answer, questions[9].choice, questions[9].answer, 4),
          this.state.answers[4].userAnswer && this.renderQuestion(questions[10].choice, questions[10].answer, questions[11].choice, questions[11].answer, 5)
        )
      );
    }
  }]);
  return Module2Act3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  updateModuleAct: _propTypes2.default.func,
  app: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module2Act3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Activities/Act3.js
// module id = 1180
// module chunks = 0